<button type="button"
        class="w-12"
        [attr.aria-label]="'Toggle' | translate"
        (click)="toggle()">
    <div class="ratio-1-1 b-a b-w-2"
         [ngClass]="selected ? 'b-col-1' : 'b-col-t'">
        @if (product) {
        <img class="rf"
             [image]="product.data.image">
        }
        @if (!product) {
        <div class="fill bg-col-51 flex flex-justify-center flex-middle s1 col-12">
            {{'None' | translate}}
        </div>
        }
        @if (selected) {
        <span class="pos-absolute top-1 right-1"
              style="width: 24px; height: 24px">
            <img class="fill"
                 image="/assets/images/sample-tick.png">
        </span>
        }
    </div>
</button>
<div class="m-t-2 left">
    <p class="s1 w-12">
        <span>{{product?.data?.name}}</span>
    </p>
    <div class="m-t-2 s1">
        @if(product?.orgPrice){
        <span class="col-11 line-through">
            +<price [value]="product.orgPrice"></price>
        </span>
        }
        <span [ngClass]="product?.orgPrice ? 'col-2' : 'col-11'">
            +<price [value]="product?.price"></price>
        </span>
    </div>
    <div class="m-t--1">
        @if (product?.parent?.isConfigurable) {
        <product-view-configurable-options class=" block"
                                           [product]="product"
                                           [isHuge]="false"
                                           [noCrossellLink]="true"
                                           [preselectSingles]="true"
                                           (selectionChange)="onSelectionChange($event.data)"
                                           (crossellProductClick)="onCrossellProductClick($event)"
                                           (init)="onProductConfigurablesInit($event)">
        </product-view-configurable-options>
        }
        @if (displayColorCrossSells) {
        <product-view-crosssell-products-color [upsellVariant]="true"
                                               [product]="product"
                                               [isHuge]="false"
                                               (productClick)="onCrossellProductClick($event)"
                                               [ngClass]="{'m-b-1' : product.familySamples?.length}"
                                               class="block"></product-view-crosssell-products-color>
        }
    </div>
    @if (product && content) {
    <button type="button"
            [iCmsModalOpen]="productViewUpsellProductModalId"
            [iCmsModalOpenData]="{content: content, product: product, onConfirm: select}"
            class="button-inline m-t-1 p1">{{'more info' | translate}}</button>
    }
</div>
